<div class="layout-ParentDiv innerDiv userKycPage">
	<div class="layout-dashboard">
            <p-toast key="toastmsg"></p-toast>

			<div class="mainDivHeader">
				<div class="leftdiv">
					<h4>User KYC List<span class="badge">{{totalRecords}}</span></h4>
				</div>
				<div class="rightDiv">
                    <button (click)="clear()" class="clearFilterBtn">
                        <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                        <span>Clear All</span>
                    </button>

                    <button class="exportBTn" (click)="exportExcel()"> <span><img
                        src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
                        Export</button>

                         <!-- <button pButton pRipple label="Export" icon="pi pi-file-excel" (click)="exportExcel()"
                        class="p-button-help mr-2" pTooltip="XLS" tooltipPosition="bottom"></button> -->
                </div>
			</div>

            <!-- <button (click)="addKyc(userId)" pButton pRipple label="Add" class="p-button-success p-col-1 "  icon="pi pi-plus"></button> -->

            <div class="mainDivBody">
                <div class="maintableDiv">
                    <div class="tableParanet">

                        <p-table class="p2-table-columns show-columns" #dt [value]="userlist" [lazy]="true" [paginator]="true"
                            [rows]="10" (onLazyLoad)="loadUserKyc($event)" [totalRecords]="totalRecords" [loading]="loading"
                            autoLayout="true" [rowsPerPageOptions]="paginationOption"
                            styleClass="p-datatable-gridlines p-datatable-striped">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th class="usernameTD">User Name 
                                        <p-sortIcon field="academyName"></p-sortIcon>
                                    </th>

                                    <!-- <th style="min-width: 100px;">Pan Image</th> -->

                                    <th class="bankDetailsTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Bank Details <p-sortIcon field="academyName"></p-sortIcon>
                                        </div>
                                    </th>

                                    <!-- <th >
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            A/C Number
                                        </div>
                                    </th>
                                    <th >
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            IFSC
                                        </div>
                                    </th> -->

                                    <th class="pannumberTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Pan Number <p-sortIcon field="academyName"></p-sortIcon>
                                        </div>
                                    </th>

                                    <th class="aadharnoTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Aadharcard Number <p-sortIcon field="academyName"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th class="gstTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            GST Number <p-sortIcon field="academyName"></p-sortIcon>
                                        </div>
                                    </th>

                                    <!-- <th >
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            State Name

                                        </div>
                                    </th>
                                    <th >
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            City Name

                                        </div>
                                    </th> -->
                                    
                                    <th class="addressTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Address
                                        </div>
                                    </th>

                                    <!-- <th >
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Zip Code

                                        </div>
                                    </th> -->

                                    <th class="dateTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Date
                                        </div>
                                    </th>

                                    <th class="statusTd p-frozen-column">
                                        <div class="p-d-flex p-jc-between p-ai-center " >
                                            Status  
                                        </div>
                                    </th>

                                    <!-- <th class="">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Action
                                        </div>
                                    </th> -->
                                </tr>

                                <tr>
                                    <th [ngSwitch]="userName" class="usernameTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                                            [value]="dt.filters['userName'] ? dt.filters['userName'].value : ''" />
                                    </th>
                                    <!-- <th [ngSwitch]="lastName" class="NameTD">
                                        
                                    </th> -->
                                    <th [ngSwitch]="gender" class="bankDetailsTD">

                                    </th>
                                    <th [ngSwitch]="pancardNumber" class="pannumberTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'pancardNumber', 'contains')"
                                            [value]="dt.filters['pancardNumber'] ? dt.filters['pancardNumber'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="adharCardNumber" class="aadharnoTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'adharCardNumber', 'contains')"
                                            [value]="dt.filters['adharCardNumber'] ? dt.filters['adharCardNumber'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="gstNumber" class="gstTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'gstNumber', 'contains')"
                                            [value]="dt.filters['gstNumber'] ? dt.filters['gstNumber'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="dob" class="addressTD">

                                    </th>
                                    <!-- <th [ngSwitch]="weddingDate" class="">
                                        <p-calendar #pCalendarId class="p-column-filter" inputId="calendar" dateFormat="dd/mm/yy"
                                            (onSelect)="setDownloadFlag(); dt.filter($event,'weddingDate', 'dateIs')"
                                            [showIcon]="true" [(ngModel)]="wdcalvalue"></p-calendar>
                                    </th> -->
                                    <th [ngSwitch]="updated_at" class="dateTD">
                                        <!-- <p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar" dateFormat="dd/mm/yy"
                                            (onSelect)="setDownloadFlag(); dt.filter($event,'updated_at', 'dateIs')"
                                            [showIcon]="true" [(ngModel)]="ucalvalue"></p-calendar> -->
                                    </th>
                                    <th [ngSwitch]="status" class="statusTd p-frozen-column" style="background: #fefef6  !important;
    border-width: 0px 0px 0px 0px;
    border-color: #EBEBEB !important;">
                                        <p-dropdown #pDropDownId [options]="statuses" appendTo="body"
                                            (onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
                                            styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
                                            <ng-template let-option pTemplate="item">
                                                <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                            </ng-template>
                                        </p-dropdown>
                                        <!-- <p-dropdown [style]="{ width: '100%' }" inputId="id" appendTo="body" [showClear]="true"
                                        [options]="statuses" [filter]="true" placeholder="All" [(ngModel)]="searchbystatus"
                                        optionLabel="label" (onChange)="onStatuSelect($event)"></p-dropdown> -->
                                    </th>
                                    <!-- <th> -->
                                        <!-- <button pButton [style]="{'margin-left':'20px'}" icon="pi pi-plus" class="p-button-rounded" (click)="addColumns()"></button> -->
                                    <!-- </th> -->
                                </tr>

                            </ng-template>
                            <ng-template pTemplate="body" let-userlist>
                                <tr class="p-selectable-row" *ngIf="noData" >
                                    <td class="usernameTD">
                                        {{userlist.userdetail[0].fullName}}
                                    </td>
                                    <!-- <td class="pan-image-td">
                                        <div class="pan-image" (click)="openHightlightImage(userlist);">
                                            <img [src]=userlist.pancardPic [alt]="userlist.name" width="300" class="shadow-4" />
                                        </div>
                                        <div class="button-div" (click)="openHightlightImage(userlist);">
                                            <button pButton pRipple type="button" icon="pi pi-eye"
                                                class="p-button-rounded"></button>
                                            <p>View Image</p>
                                        </div>
                                    </td> -->
                                    <td class="bankDetailsTD">
                                        <span class="bankListdiv" *ngFor="let bankdata of userlist.bankData">
                                        <span><b>Bank Name:</b> {{bankdata.bankName}}</span>
                                        <span><b>A/C Number:</b> {{bankdata.bankAccountNumber}}</span>
                                        <span><b>IFSC Number:</b> {{bankdata.ifsc}}</span>
                                    </span>

                                    </td>

                                    <!-- <td>
                                        {{userlist.accountNumber}}
                                    </td>
                                    <td>
                                        {{userlist.ifsc}}
                                    </td> -->
                                    <td class="pannumberTD">
                                        {{userlist.panCardNumber}}
                                    </td>
                                    <td class="aadharnoTD">
                                        {{userlist.aadhaarCardNumber }}
                                    </td>

                                    <td class="gstTD">
                                        {{userlist.gstNumber}}
                                    </td>

                                    <!-- <td>
                                        {{userlist.statename}}
                                    </td>
                                    <td>
                                        {{userlist.cityname}}
                                    </td> -->
                                    <td class="addressTD">
                                    <span *ngIf="userlist.isAadharVerified"> {{userlist.fullAddress?.house}},{{userlist.fullAddress?.street}},{{userlist.fullAddress?.landmark}},{{userlist.fullAddress?.po}}-{{userlist.fullAddress?.pincode}},{{userlist.fullAddress?.state}},{{userlist.fullAddress?.country}}</span>
                                    </td>
                                    <!-- <td>
                                        {{userlist.zipcode}}
                                    </td> -->
                                    <td class="dateTD">
                                        {{userlist.created_at | date:'dd/MM/yyyy'}}
                                    </td>
                                    
                                    <td class="statusTd p-frozen-column">
                                        <div class="status-button w-100" >
                                        </div>
                                        <p-tag class="bg-success text-white" *ngIf="userlist.isDocumentComplete"
                                            [rounded]="true">Approved</p-tag>
                                        <p-tag class="bg-warning text-dark" *ngIf="!userlist.isDocumentComplete"
                                            [rounded]="true">Pending</p-tag>
                                    </td>
                                    <!-- <td class="action-button-td">
                                        <div class="status-button w-100">
                                            <p-button icon="pi pi-pencil" [ngClass]="{'disabled-button-class': userlist.isRejected}" [rounded]="true" severity="warning" [disabled]="userlist.isRejected"  class="buttons btn btn-warning " routerLink="/manage/user/kyc/add-kyc/{{userlist.Id}}/0/{{userlist.userId}}"  pTooltip="Edit " tooltipPosition="bottom"> </p-button>
                                            <p-button icon="pi pi-check"  [ngClass]="{'disabled-button-class': !userlist.isDocumentComplete || userlist.status || userlist.isRejected}" [rounded]="true" severity="success" [disabled]="!userlist.isDocumentComplete || userlist.status || userlist.isRejected"  class="buttons btn btn-success" (click)="changeStatus(userlist)" pTooltip="Approved " tooltipPosition="bottom"> </p-button>
                                            <p-button icon="pi pi-times"  [ngClass]="{'disabled-button-class': !userlist.isDocumentComplete || userlist.status || userlist.isRejected}"  [rounded]="true" severity="danger" [disabled]="!userlist.isDocumentComplete || userlist.status || userlist.isRejected" class="buttons btn btn-danger" (click)="showrejectmodal(userlist)" pTooltip="Reject" tooltipPosition="bottom"> </p-button>
                                        </div>
                                    </td> -->

                                        <!-- <button pButton pRipple icon="pi pi-pencil" 
                                            class="p-button-rounded p-button-success p-mr-2" pTooltip="edit"
                                            ></button> -->

                                    <!-- <td  class="actionTD">

                                    </td> -->

                                </tr>
                            </ng-template>
                            <!-- <ng-template pTemplate="summary">
                                <div class="flex align-items-center justify-content-between">
                                    In total there are {{totalRecords}} KYC records
                                </div>
                            </ng-template> -->
                        </p-table>
                    </div>
                </div>        
            </div>        
    </div>
</div>


<p-galleria [(value)]="userlist" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '600px' }" [numVisible]="7" [circular]="true" [fullScreen]="true"
    [showItemNavigators]="false" [showThumbnails]="false">
    <ng-template pTemplate="item" let-userlist>
        <img [src]=showHighlightImg [alt]="userlist.name" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>
<p-dialog header="Mention Reject Reason" [(visible)]="rejectKyc" [modal]="true" [style]="{ width: '400px' }"
    [draggable]="false" [resizable]="false" class="modal-payment-select" id="rejectModal">
    <form [formGroup]="rejectUpdateForm" >
        <div class="p-grid">
            <div class="col-12">
                <div class="form-div">
                    <label for="comment"> Add Reason <span class="mandatory-fields ">*</span>
                    </label>
                    <textarea pInputTextarea rows="5" formControlName="comment"
                        [ngClass]="{ 'is-invalid': submitted && f.comment.errors }"></textarea>
                    <div *ngIf="((submitted && f.comment.errors) || (f.comment.errors && (f.comment.dirty || f.comment.touched)))"
                        class="invalid-feedback">
                        <div *ngIf="f.comment.errors.required">
                            Reason is required</div>
                    </div>
                </div>
            </div>
            <div class="col-12 footer-forms">
                <button class="btn cancel-btn" (click)="rejectKyc = false"> Cancel </button>
						<button class="btn rejectBtn" (click)="changeStatusToReject()" type="submit"> Reject </button>
 
            </div>
        </div>
    </form>
</p-dialog>
<p-dialog header="Reason of Rejection" [(visible)]="rejectKycReasonView" [modal]="true" [style]="{ width: '500px' }"
    [draggable]="false" [resizable]="false" class="modal-payment-select">
   <div>
    {{viewReason}}
   </div>
</p-dialog>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>